(function(angular) {
    'use strict';

    angular.module('aprima-core-ui').filter('apHasFeature', [
        '_',
        'ServerInfoRepository',
        apHasFeature,
    ]);

    function apHasFeature(
        _,
        ServerInfoRepository
    ) {
        return hasFeature;

        function hasFeature(features) {
            if(!features) {
                return false;
            }

            var featureList;
            if(_.isArray(features)) {
                featureList = features;
            }
            else if(_.isString(features)) {
                featureList = features.split(',');
            }
            else {
                return false;
            }

            var featureResult = ServerInfoRepository.isFeatureSupported(featureList);

            return featureResult;
        }
    }

})(window.angular);